import tagTester from './_tagTester.js';

export default tagTester('RegExp');



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/isRegExp.js
// module id = 498
// module chunks = 8